import type { TFunction } from 'i18next';

/** Resolve a dynamic attribute label from attribute key; falls back to API/admin label. */
export function translateAttributeLabel(attrKey: string, fallbackLabel: string, t: TFunction): string {
  if (!attrKey) return fallbackLabel;
  return t(`pages.dynamicAttributes.labels.${attrKey}`, { defaultValue: fallbackLabel });
}

/** Resolve a select option display string (often Arabic values stored in DB). */
export function translateAttributeOption(attrKey: string, value: string, t: TFunction): string {
  if (value === null || value === undefined) return '';
  const v = String(value).trim();
  if (!v) return '';
  return t(`pages.dynamicAttributes.options.${attrKey}.${v}`, { defaultValue: v });
}
